var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-input',_vm._b({ref:"input",staticClass:"input-llood-number",attrs:{"type":"number"},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}},'el-input',Object.assign({}, _vm.$attrs, _vm.$props),false))}
var staticRenderFns = []

export { render, staticRenderFns }